import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { displayDate, displayDosage, LensHit, parseBlockDate, processCardItem } from "Backend";

export interface MedicationHitsTableProps {
  lensHits: [number, LensHit][];
}

const MedicationHitsTable = (props: MedicationHitsTableProps) => {
  const { lensHits } = props;

  return (
    <div>
      <Table size="small">
        <TableHead>
          <TableCell />
          <TableCell>Finding</TableCell>
          <TableCell>Date</TableCell>
          <TableCell>Dosage</TableCell>
          <TableCell>Quantity</TableCell>
          <TableCell>NDC</TableCell>
          <TableCell>Record Type</TableCell>
          <TableCell>Document</TableCell>
        </TableHead>
        <TableBody>
          {lensHits.map(([idx, hit]) => {
            const { entityOfItem, block, sectionText } = processCardItem(hit);
            return (
              <TableRow key={idx}>
                <TableCell>{idx + 1}</TableCell>
                <TableCell>{hit.ruleDescription}</TableCell>
                <TableCell>{hit.block.date && displayDate(parseBlockDate(hit.block.date))}</TableCell>
                <TableCell>{displayDosage(entityOfItem?.dosage)}</TableCell>
                <TableCell>{entityOfItem?.medQuantity}</TableCell>
                <TableCell>{entityOfItem?.ndcCode}</TableCell>
                <TableCell>{sectionText}</TableCell>
                <TableCell>{block.documentName}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default MedicationHitsTable;
